import { Pipe, PipeTransform } from '@angular/core';
import { TrainingProposalsPluginService } from './trainingproposals-plugin.service';

@Pipe({
    name: 'trainerpipe',
    standalone: false
})
export class TrainerPipe implements PipeTransform {
  public trainers: any;

  constructor(private service: TrainingProposalsPluginService) {
    this.service.getTrainers().subscribe((data) => {
      this.trainers = data;
    });
  }

  transform(id: string): any {
    return this.service.getValue(id, this.trainers);
  }
}
